import { presetWind3 } from '@unocss/preset-wind3'

// Mirror of the Tailwind v4 `@theme` block in src/index.css.
// Kept hand-synced for now; a build-time generator from CSS variables
// could automate this later if drift becomes a problem.
export default {
  presets: [presetWind3()],
  theme: {
    colors: {
      navy: {
        50:  '#eef1f9',
        100: '#dce3f4',
        200: '#c7d0e8',
        700: '#253580',
        800: '#1e2f6e',
        900: '#1a2a5e',
        950: '#111d42',
      },
      'brand-blue':  '#0470be',
      'sky-soft':    '#dbedf9',
      'corsair-red': '#e63946',
      // Orbit "Cosmos" design system — primary palette (additive).
      iris: {
        50:  '#eef0fe', 100: '#e3e3fd', 200: '#ccccfb', 300: '#aaa6f6',
        400: '#8b84f1', 500: '#6d63ea', 600: '#5a4fe0', 700: '#4a3fc7',
        800: '#3c34a0', 900: '#332e7f',
      },
      space: {
        700: '#262a4d', 800: '#1b1d38', 850: '#14152b', 900: '#0d0e1d', 950: '#090a16',
      },
      cyan: { 400: '#22d3ee', 500: '#06b6d4', 600: '#0891b2' },
    },
    fontFamily: {
      sans:    "'Plus Jakarta Sans', ui-sans-serif, system-ui, -apple-system, sans-serif",
      display: "'Space Grotesk', 'Plus Jakarta Sans', ui-sans-serif, system-ui, sans-serif",
      mono:    "'JetBrains Mono', ui-monospace, 'SF Mono', 'Cascadia Code', monospace",
    },
    fontSize: {
      '3xs': ['0.625rem',  { lineHeight: '0.875rem' }],
      '2xs': ['0.6875rem', { lineHeight: '1rem' }],
    },
  },
}
